import { jsx as _jsx } from "react/jsx-runtime";
const Button = ({ onClick, children, className = '', disabled = false, type = 'button', }) => {
    return (_jsx("button", { type: type, className: `text-[length:var(--text-11)] font-medium font-inherit bg-blue-900 border-2 border-blue-900 text-white hover:bg-blue-950 transition-colors duration-200 ${className}`, onClick: onClick, disabled: disabled, children: children }));
};
export default Button;
